import React, { useState } from "react";
import SafeIcon from "../common/SafeIcon";
import { Helmet } from "react-helmet-async";
import * as FiIcons from "react-icons/fi";

const { FiChevronDown } = FiIcons;

export default function FAQ({ data, title = "Frequently Asked Questions" }) {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="py-24 px-6 bg-gray-50">

            {/* ✅ FAQ Schema Added */}
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": data.map(item => ({
                            "@type": "Question",
                            "name": item.question,
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": item.answer
                            }
                        }))
                    })}
                </script>
            </Helmet>

            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl font-bold text-secondary text-center mb-12">
                    {title}
                </h2>

                <div className="space-y-4">
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl shadow-sm overflow-hidden"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full flex items-center justify-between p-6 text-left"
                            >
                                <span className="font-semibold text-gray-800">
                                    {item.question}
                                </span>
                                <SafeIcon
                                    icon={FiChevronDown}
                                    className={`text-primary transition-transform ${activeIndex === index ? "rotate-180" : ""
                                        }`}
                                />
                            </button>

                            {activeIndex === index && (
                                <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                                    {item.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}